/*
  Flo advertorial "7 mistakes": countdown, tap checklist, floor test,
  posture slider and week tabs. One delegated listener per event, so it
  keeps working when the theme editor re-renders a section, and a guard
  so it runs once even though every flo-adv7 section includes this file.
*/
(function () {
  if (window.__floAdv7) return;
  window.__floAdv7 = true;

  function pad(x) { return String(x).padStart(2, '0'); }
  function tick() {
    var now = new Date();
    var end = new Date(now);
    end.setHours(24, 0, 0, 0);
    var s = Math.max(0, Math.floor((end - now) / 1000));
    var t = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60);
    document.querySelectorAll('[data-fa7-countdown]').forEach(function (el) { el.textContent = t; });
  }
  tick();
  setInterval(tick, 1000);

  function press(group, active) {
    group.forEach(function (b) { b.setAttribute('aria-pressed', b === active ? 'true' : 'false'); });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.fa7-ck, .fa7-opt, .fa7-tl__tab');
    if (!btn) return;

    if (btn.classList.contains('fa7-ck')) {
      var list = btn.closest('[data-fa7-checklist]');
      btn.setAttribute('aria-pressed', btn.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
      var all = list.querySelectorAll('.fa7-ck');
      var n = list.querySelectorAll('.fa7-ck[aria-pressed="true"]').length;
      var msg = list.querySelector('[data-fa7-msg]');
      if (msg) {
        msg.hidden = n === 0;
        msg.textContent = (list.getAttribute('data-msg') || '').replace('[n]', n).replace('[total]', all.length);
      }
      return;
    }

    if (btn.classList.contains('fa7-opt')) {
      var test = btn.closest('[data-fa7-floor]');
      press(test.querySelectorAll('.fa7-opt'), btn);
      var res = test.querySelector('[data-fa7-result]');
      res.querySelector('[data-fa7-title]').textContent = btn.getAttribute('data-title') || '';
      res.querySelector('[data-fa7-body]').textContent = btn.getAttribute('data-body') || '';
      res.hidden = false;
      return;
    }

    var tl = btn.closest('[data-fa7-timeline]');
    press(tl.querySelectorAll('.fa7-tl__tab'), btn);
    tl.querySelector('[data-fa7-bar]').style.width = btn.getAttribute('data-width') || '0%';
    tl.querySelector('[data-fa7-title]').textContent = btn.getAttribute('data-title') || '';
    tl.querySelector('[data-fa7-body]').textContent = btn.getAttribute('data-body') || '';
  });

  document.addEventListener('input', function (e) {
    var range = e.target;
    if (!range.matches || !range.matches('[data-fa7-split]')) return;
    var fig = range.closest('[data-fa7-posture]');
    if (fig) fig.querySelector('.fa7-pc').style.setProperty('--split', range.value + '%');
  });

  // Keep the spacer under the page exactly as tall as the fixed sticky bar.
  function fitSticky() {
    var bar = document.querySelector('.fa7-sticky');
    if (bar) document.documentElement.style.setProperty('--fa7-sticky-h', bar.offsetHeight + 'px');
  }
  if (window.ResizeObserver) {
    var ro = new ResizeObserver(fitSticky);
    var watch = function () { var bar = document.querySelector('.fa7-sticky'); if (bar) ro.observe(bar); fitSticky(); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
    document.addEventListener('shopify:section:load', watch);
  }

  document.addEventListener('shopify:section:load', tick);
})();
